/**
 * соотношения id проектов и их анимаций в папке /static/lottie
 */
export const mapping = {
  5: "amoniy",
  21: "gachalav",
  23: "sasahub",
  // 24: "roisa",
  25: "mylib",
  27: "minkom",
  28: "tuda-suda",
  29: "venchurniy-forum",
  // 30: "ortocity",
  33: "gotoyou",
  34: "aist-club",
  35: "expocentr",
  36: "tr-go",
  37: "iknow",
  // 38: "babymarket",
  // 39: "uni",
  40: "zelenoe",
  41: "ataev",
  42: "precardo",
  43: "sakari",
  44: "sharifa",
  45: "skins",
  46: "wedpul",
};
